<template>
	<div class="vx-row">
		<div class="vx-col w-full">
			
			<div class="mb-6">
				<strong class="block mb-4">Metode Pengambilan Dana</strong>
				<v-select
					class="w-full rounded-lg"
					v-validate="'required'"
					name="metode"
					v-model="metode"
					:options="metodeOptions"
				/>
				<span class="text-danger text-sm" v-show="errors.has('metode')">
					<strong>{{ errors.first('metode') }}</strong>
				</span>
			</div>

			<div class="mb-6" v-if="metode === 'Transfer'">
				<strong class="block mb-4">Bank</strong>
				<vs-input
					class="w-full rounded-lg"
					name="bank"
					:danger="errors.has('bank')"
					v-validate="metode === 'Transfer' ? 'required' : ''"
					v-model="bank"
				/>
				<span class="text-danger text-sm" v-show="errors.has('bank')">
					<strong>{{ errors.first('bank') }}</strong>
				</span>
			</div>

			<div class="mb-6" v-if="metode === 'Transfer'">
				<strong class="block mb-4">No. Rekening Bank</strong>
				<vs-textarea
					name="no_rekening"
					class="w-full rounded-lg"
					v-model="no_rekening"
					v-validate="metode === 'Transfer' ? 'required' : ''"
					:danger="errors.has('no_rekening')"
				/>
				<span class="text-danger text-sm" v-show="errors.has('no_rekening')">
					<strong>{{ errors.first('no_rekening') }}</strong>
				</span>
			</div>
			
			<div class="vx-row justify-center md:justify-end">
				<div class="vx-col w-full md:w-1/2">
					<vs-button class="w-full" @click.prevent="submit">
						Selanjutnya
					</vs-button>
				</div>
			</div>

		</div>
	</div>
</template>
<script>
	import { Validator } from 'vee-validate'
	import vSelect from 'vue-select'

	const dict = {
		  custom: {
		    metode: {
		      required: 'Harap pilih metode pengambilan dana'
		    },
		    bank: {
		    	required: 'Harap masukan nama bank'
		    },
		    no_rekening: {
		    	required: 'Harap masukan no rekening anda'
		    }
		  }
	}

	Validator.localize('en', dict)
	export default {
		components: {
			vSelect
		},
		data: () => ({
			metode: null,
			metodeOptions: ['Transfer', 'Ambil Sendiri'],
			bank: null,
			no_rekening: null
		}),
		methods: {
			submit() {
				this.$validator.validateAll().then(res => {
					if(res) {
						this.$emit('submit', {
							metode: this.metode,
							bank: this.bank,
							no_rekening: this.no_rekening
						})
					}
				})
			}
		}
	}
</script>